module.exports = __webpack_public_path__ + "media/images/lb/957-e69509169aa58a282d8f6619b760b69f.svg";